import { NewContentCardFooter } from './Footer';
import { NewContentCardHeader } from './Header';
import { NewContentCardRoot } from './Root';
import { NewContentCardTitle } from './Title';

export const NewContentCard = {
  Root: NewContentCardRoot,
  Header: NewContentCardHeader,
  Title: NewContentCardTitle,
  Footer: NewContentCardFooter,
};
